<ng-container *ngIf="large, else medium">
    <h3 class="fw500 margin_top_very_small margin_bottom_large" tabindex="0">{{title}}</h3>
</ng-container>
<ng-template #medium>
    <h4 class="montserrat_500 margin_top_0 margin_bottom_medium" tabindex="0">{{title}}</h4>
</ng-template>